import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import Delete from "@material-ui/icons/Delete";
import { useModalExcludeStyles } from "./styles";

type DeleteConfirmationModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    title: string;
    legend?: string | string[];
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
    open,
    onClose,
    onConfirm,
    loading,
    title,
    legend,
}) => {
    const { classes } = useModalExcludeStyles();
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <Card>
                <CardHeader
                    avatar={<Delete />}
                    className={classes.cardHeader}
                    title={<Typography variant="h5">{title}</Typography>}
                />
            </Card>
            <CardContent className={classes.cardContent}>
                {legend ? (
                    Array.isArray(legend) ? (
                        legend.map((text, index) => (
                            <Typography key={index} className={classes.textWarning}>
                                {text}
                            </Typography>
                        ))
                    ) : (
                        <Typography className={classes.textWarning}>
                            {legend}
                        </Typography>
                    )
                ) : (
                    <>
                        <Typography className={classes.textWarning}>
                            Você está prestes a remover este item do sistema.
                        </Typography>
                        <Typography className={classes.textWarning}>
                            Tem certeza que deseja continuar?
                        </Typography>
                    </>
                )}
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button className={classes.button} onClick={onClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    className={classes.deleteButton}
                    disabled={loading}
                    onClick={onConfirm}
                >
                    {loading ? "Excluindo..." : "Excluir"}
                </Button>
            </CardActions>
        </Dialog>
    );
};

export default DeleteConfirmationModal;
